import { createRoute, useEntityUrl } from 'framework/routing';
import { NEW_PROJECT_PATH } from 'domain/shared/newProject';
import { ResourceId } from 'framework/crud';

// permissions
export const READ_LIST = 'DELIVERY_PROJECT_READ_LIST';

// new permission for dashboard
export const READ_LIST_DASHBOARD = 'DELIVERY_PROJECT_SEARCH_BASE_PROJECT';
export const CREATE_PROJECT = 'DELIVERY_PROJECT_CREATE';
export const UPDATE_PROJECT = 'DELIVERY_PROJECT_UPDATE';
export const BUDGET_UPDATE = 'DELIVERY_BUDGET_UPDATE';
export const BUDGET_READ_LIST = 'DELIVERY_BUDGET_READ_LIST';
export const BILLING_SCHEDULE_READ_LIST = 'DELIVERY_BILLING_SCHEDULE_READ_LIST';
export const CREATE_RISK = 'DELIVERY_PROJECT_CREATE_RISK';
export const SEARCH_RISK = 'DELIVERY_PROJECT_SEARCH_RISK';
export const CREATE_CHANGE_REQUEST = 'DELIVERY_PROJECT_CREATE_CHANGE_REQUEST';
export const REPORT_WASTE = 'FINANCE_WASTE_REPORT_WASTE';
export const READ_EVM = 'DELIVERY_PROJECT_READ_EVM';
export const CREATE_EVM = 'DELIVERY_PROJECT_CREATE_EVM';
export const DOWNLOAD_EVM = 'DELIVERY_PROJECT_DOWNLOAD_EVM';
export const APPROVE_REJECT_REPORT_RECIPIENT = 'DELIVERY_PROJECT_APPROVE_REJECT_REPORT_RECIPIENT';
export const SAVE_CUSTOMER_REPORT_AS_DRAFT = 'DELIVERY_PROJECT_SAVE_CUSTOMER_REPORT_AS_DRAFT';
export const SUBMIT_CUSTOMER_REPORT_GLOBAL = 'DELIVERY_PROJECT_SUBMIT_CUSTOMER_REPORT';
export const FINANCE_WASTE_GET_BY_ID = 'FINANCE_WASTE_GET_BY_ID';
export const FINANCE_WASTE_UPDATE_WASTE = 'FINANCE_WASTE_UPDATE_WASTE';
export const REUSE_PROJECT = 'CREATE_BATCH_RISK';
export const UPDATE_UPCOMING_CHANGE = 'DELIVERY_PROJECT_UPDATE_UPCOMING_CHANGE';
// TODO: Replace with the dedicated START_PROJECT_REVIEW permission once it is available.
export const START_PROJECT_REVIEW = 'DELIVERY_BUDGET_UPDATE_BUDGET_ITEM_STATUS';

//graphql specific
export const GRAPHQL_PROJECT_TEAM_VIEW = 'GRAPHQL__TEAM__VIEW';
export const GRAPHQL_PROJECT_SDLC_VIEW = 'GRAPHQL__SDLC__VIEW';
export const GRAPHQL_PROJECT_CUSTOMER_REPORT_VIEW = 'GRAPHQL__CUSTOMER_REPORT__VIEW';
export const GRAPHQL_PROJECT_EVM_VIEW = 'GRAPHQL__EVM__VIEW';
export const GRAPHQL_PROJECT_BUDGET_VIEW = 'GRAPHQL__BUDGET__VIEW';
export const GRAPHQL_PROJECT_BUSINESS_OUTCOME_VIEW = 'GRAPHQL__BUSINESS_OUTCOME__VIEW';
export const GRAPHQL_PROJECT_CONTROL_PLANE_VIEW = 'GRAPHQL__CONTROL_PLANE__VIEW';
export const GRAPHQL_PROJECT_MILESTONE_VIEW = 'GRAPHQL__MILESTONE__VIEW';
export const GRAPHQL_PROJECT_RISK_VIEW = 'GRAPHQL__RISK__VIEW';
export const GRAPHQL_PROJECT_CLIENT_CONFIRMATION_VIEW = 'GRAPHQL__CLIENT_CONFIRMATION__VIEW';
export const GRAPHQL_PROJECT_CLIENT_PORTAL_VIEW = 'GRAPHQL__CLIENT_PORTAL__VIEW';
export const GRAPHQL_PROJECT_ASSUMPTION_VIEW = 'GRAPHQL__ASSUMPTION__VIEW';
export const GRAPHQL_PROJECT_ASSUMPTION_REVIEW = 'GRAPHQL__ASSUMPTION__REVIEW';
export const GRAPHQL_PROJECT_STAKEHOLDERS_VIEW = 'GRAPHQL__STAKEHOLDER__VIEW';
export const GRAPHQL_PROJECT_ENGINEERING_VIEW = 'GRAPHQL__ENGINEERING__VIEW';
export const GRAPHQL_CRITICAL_PERIOD_VIEW = 'GRAPHQL__CRITICAL_PERIOD__VIEW';

export const GRAPHQL__PROJECT_VIEW__NAVIGATION_SWITCH_TO_STAFFING_VIEW =
  'GRAPHQL__PROJECT_VIEW_NAVIGATION__SWITCH_TO_STAFFING_VIEW';
export const PROJECT_CREATE_RISK = 'CREATE_RISK';
export const PROJECT_CREATE_CLIENT_TASK = 'DELIVERY_PROJECT_CREATE_CLIENT_TASK';
export const PROJECT_READ_CLIENT_TASK = 'DELIVERY_PROJECT_READ_CLIENT_TASK';
export const READ_CLIENT_TASK = 'READ_CLIENT_TASK';
export const CREATE_CLIENT_TASK = 'CREATE_CLIENT_TASK';
export const PROJECT_UPDATE_RISK = 'UPDATE';
export const PROJECT_READ_TEAM_MEMBER_ALIAS = 'READ_TEAM_MEMBER_ALIAS';
export const SUBMIT_CUSTOMER_REPORT = 'SUBMIT_CUSTOMER_REPORT';
export const SAVE_REPORT_AS_DRAFT = 'SAVE_CUSTOMER_REPORT_AS_DRAFT';
export const CREATE_REQUEST = 'CREATE_CHANGE_REQUEST';
export const READ_CHANGE_REQUEST = 'READ';
export const UPDATE_CHANGE_REQUEST = 'UPDATE';
export const APPROVE_CHANGE_REQUEST = 'APPROVE';
export const SEND_FOR_SIGNING = 'SEND_FOR_SIGNING';
export const SAVE_EXTERNAL_REPORT = 'SAVE_EXTERNAL_CUSTOMER_REPORT';
export const GET_CUSTOMER_REPORT = 'GET_CUSTOMER_REPORT';
export const CANCEL_CUSTOMER_REPORT = 'CANCEL_CUSTOMER_REPORT';
export const APPROVE_CUSTOMER_REPORT = 'APPROVE_CUSTOMER_REPORT';
export const REJECT_CUSTOMER_REPORT = 'REJECT_CUSTOMER_REPORT';
export const SEND_CUSTOMER_REPORT = 'SEND_CUSTOMER_REPORT';
export const CREATE_CRITICAL_PERIOD = 'CREATE_CRITICAL_PERIOD';
export const RISK_UPDATE = 'UPDATE';
export const RISK_DELETE = 'DELETE';
export const RISK_ESCALATE = 'ESCALATE';
export const RISK_DEESCALATE = 'DEESCALATE';
export const RISK_CREATE_TIMELINE_ENTRY = 'CREATE_USER_TIMELINE_ENTRY';

export const useNewProjectRoute = () => {
  const routers = createRoute({ listRoute: NEW_PROJECT_PATH });

  const tabMenuRoutes = {
    controlsTabRoute: `controls`,
    outcomesTabRoute: `outcomes`,
    risksTabRoute: `risks`,
    financeTabRoute: `finance`,
    evmTabRoute: `evm`,
    customerReportTabRoute: `customer-report`,
    sdlcTabRoute: `sdlc`,
    teamTabRoute: `team`,
    clientPortalTabRoute: `client-portal`,
    clientPortalInviteTabRoute: `invite`,
    clientPortalApproveInviteTabRoute: `invite/:requestId`,
    assumptionsTabRoute: `assumptions`,
    acceptanceTabRoute: `acceptance`,
    timelineTabRoute: `timeline/:timelineEntryId?`,
    stakeholdersTabRoute: `stakeholders`,
    engineeringTabRoute: `engineering`,
  };

  const pageShortRoutes = {
    createRiskRoute: `risk`,
    updateRiskRoute: `risk/:riskId/:timelineEntryId?`,
    createClientPortalTaskShortRoute: `client-portal-task`,
    viewClientPortalTaskShortRoute: `client-portal-task/:taskId`,
    createProjectReviewRoute: 'project-review',
    summaryReviewRoute: 'summary-review/:reviewId',
    confirmVirtualRoute: 'confirm-virtual',
    teamPositionsRoute: 'team/positions',
    createCustomerReportRoute: `customer-report/create`,
    updateCustomerReportRoute: `customer-report/:reportId/update`,
    approveCustomerReportRoute: `customer-report/:reportId/approve`,
    newCreateWasteRoute: 'waste',
    updateWasteRoute: 'waste/:wasteId',
    previewWasteRoute: 'waste/:wasteId/preview',
    newChangeRequestRoute: 'change-request',
    updateChangeRequestRoute: 'change-request/:requestId',
    previewChangeRequestRoute: 'change-request/:requestId/preview',
    reviewAssumptionRoute: 'assumptions/:assumptionId/review',
    createCriticalPeriodShortRoute: 'critical-period/create',
    updateCriticalPeriodShortRoute: 'critical-period/:criticalPeriodId/update',
  };

  return {
    ...routers,
    listRoute: `${routers.listRoute}`,
    dashboardRoute: `${routers.listRoute}/dashboard`,
    ...tabMenuRoutes,
    // Pages
    ...pageShortRoutes,
    confirmVirtualFullRoute: `${routers.singleEntityRoute}/${pageShortRoutes.confirmVirtualRoute}`,
    teamPositionsFullRoute: `${routers.singleEntityRoute}/${pageShortRoutes.teamPositionsRoute}`,
    createRiskFullRoute: `${routers.singleEntityRoute}/${pageShortRoutes.createRiskRoute}`,
    updateRiskFullRoute: `${routers.singleEntityRoute}/${pageShortRoutes.updateRiskRoute}`,
    createClientPortalTaskRoute: `${routers.singleEntityRoute}/${pageShortRoutes.createClientPortalTaskShortRoute}`,
    viewClientPortalTaskRoute: `${routers.singleEntityRoute}/${pageShortRoutes.viewClientPortalTaskShortRoute}`,
    createProjectReviewFullRoute: `${routers.singleEntityRoute}/${pageShortRoutes.createProjectReviewRoute}`,
    summaryReviewFullRoute: `${routers.singleEntityRoute}/${pageShortRoutes.summaryReviewRoute}`,
    updateBudgetFullRoute: `${routers.singleEntityRoute}/update-budget`,
    createCustomerReportFullRoute: `${routers.singleEntityRoute}/${pageShortRoutes.createCustomerReportRoute}`,
    updateCustomerReportFullRoute: `${routers.singleEntityRoute}/${pageShortRoutes.updateCustomerReportRoute}`,
    approveCustomerReportFullRoute: `${routers.singleEntityRoute}/${pageShortRoutes.approveCustomerReportRoute}`,
    newCreateWasteFullRoute: `${routers.singleEntityRoute}/${pageShortRoutes.newCreateWasteRoute}`,
    updateWasteFullRoute: `${routers.singleEntityRoute}/${pageShortRoutes.updateWasteRoute}`,
    previewWasteFullRoute: `${routers.singleEntityRoute}/${pageShortRoutes.previewWasteRoute}`,
    newChangeRequestFullRoute: `${routers.singleEntityRoute}/${pageShortRoutes.newChangeRequestRoute}`,
    updateChangeRequestFullRoute: `${routers.singleEntityRoute}/${pageShortRoutes.updateChangeRequestRoute}`,
    previewChangeRequestFullRoute: `${routers.singleEntityRoute}/${pageShortRoutes.previewChangeRequestRoute}`,
    reviewAssumptionFullRoute: `${routers.singleEntityRoute}/${pageShortRoutes.reviewAssumptionRoute}`,
    createCriticalPeriodRoute: `${routers.singleEntityRoute}/${pageShortRoutes.createCriticalPeriodShortRoute}`,
    updateCriticalPeriodRoute: `${routers.singleEntityRoute}/${pageShortRoutes.updateCriticalPeriodShortRoute}`,

    engineeringRoute: `${routers.singleEntityRoute}/engineering`,
    reuseDataFullRoute: `${routers.singleEntityRoute}/reuse-data`,
    billingRoute: `${routers.singleEntityRoute}/billing/:requestId?`,
    createBillingRequestRoute: `/billing/:billingScheduleId/:billingItemId/create`,
    updateBillingRequestRoute: `/billing/:billingScheduleId/:billingRequestId/update`,
    approveBillingRequestRoute: `/billing/:billingScheduleId/:billingRequestId/approve`,
    previewBillingRequestRoute: `/billing/:billingScheduleId/:billingRequestId/preview`,
  };
};

export const useNewProjectUrl = () => {
  const { getSingleEntityUrl, getListUrl, ...restUrls } = useEntityUrl({
    baseLink: NEW_PROJECT_PATH,
  });
  return {
    ...restUrls,
    getListUrl,
    getSingleEntityUrl,
    getDashboardUrl: () => `${getListUrl()}/dashboard`,
    // Tabs menu
    getControlsUrl: (id?: ResourceId) => `${getSingleEntityUrl(id)}/controls`,
    getFinanceUrl: (id?: ResourceId) => `${getSingleEntityUrl(id)}/finance`,
    getEVMUrl: (id?: ResourceId) => `${getSingleEntityUrl(id)}/evm`,
    getProjectTeamUrl: (id?: ResourceId) => `${getSingleEntityUrl(id)}/team`,
    getProjectTimelineUrl: (id?: ResourceId) => `${getSingleEntityUrl(id)}/timeline`,
    getSDLCUrl: (id?: ResourceId) => `${getSingleEntityUrl(id)}/sdlc`,
    getCustomerReportUrl: (id?: ResourceId) => `${getSingleEntityUrl(id)}/customer-report`,
    getOutcomesUrl: (id?: ResourceId) => `${getSingleEntityUrl(id)}/outcomes`,
    getAssumptionsUrl: (id?: ResourceId) => `${getSingleEntityUrl(id)}/assumptions`,
    getRisksUrl: (id?: ResourceId) => `${getSingleEntityUrl(id)}/risks`,
    getAcceptanceUrl: (id?: ResourceId) => `${getSingleEntityUrl(id)}/acceptance`,
    getStakeholdersUrl: (id?: ResourceId) => `${getSingleEntityUrl(id)}/stakeholders`,
    getEngineeringUrl: (id?: ResourceId) => `${getSingleEntityUrl(id)}/engineering`,
    getReuseDataUrl: (id?: ResourceId) => `${getSingleEntityUrl(id)}/reuse-data`,
    getProjectClientPortalUrl: (id?: ResourceId) => `${getSingleEntityUrl(id)}/client-portal`,
    getProjectClientPortalInviteUrl: (id?: ResourceId) => `${getSingleEntityUrl(id)}/client-portal/invite`,
    getProjectClientPortalApproveInviteUrl: (id?: ResourceId, requestId?: string) =>
      `${getSingleEntityUrl(id)}/client-portal/invite/${requestId}`,
    getConfirmVirtualUrl: (id?: ResourceId) => `${getSingleEntityUrl(id)}/confirm-virtual`,
    //
    getUpdateChangeRequestUrl: (id: ResourceId, requestId: string) =>
      `${getSingleEntityUrl(id)}/change-request/${requestId}`,
    getPreviewChangeRequestUrl: (id: ResourceId, requestId: string) =>
      `${getSingleEntityUrl(id)}/change-request/${requestId}/preview`,
    getCreateChangeRequestUrl: (id: ResourceId) => `${getSingleEntityUrl(id)}/change-request`,
    getReviewAssumptionUrl: (id?: ResourceId, assumptionId?: string) =>
      `${getSingleEntityUrl(id)}/assumptions/${assumptionId}/review`,
    getUpdateBudgetUrl: (id?: ResourceId) => `${getSingleEntityUrl(id)}/update-budget`,
    getCreateCustomerReportUrl: (id?: ResourceId) => `${getSingleEntityUrl(id)}/customer-report/create`,
    getUpdateCustomerReportUrl: (id?: ResourceId, reportId?: string) =>
      `${getSingleEntityUrl(id)}/customer-report/${reportId}/update`,
    getApproveCustomerReportUrl: (id?: ResourceId, reportId?: string) =>
      `${getSingleEntityUrl(id)}/customer-report/${reportId}/approve`,
    getCreateProjectReviewUrl: (id?: ResourceId) => `${getSingleEntityUrl(id)}/project-review`,
    getSummaryReviewUrl: (id?: ResourceId, reviewId?: string) => `${getSingleEntityUrl(id)}/summary-review/${reviewId}`,
    getCreateClientPortalTaskUrl: (id?: ResourceId) => `${getSingleEntityUrl(id)}/client-portal-task`,
    getProjectClientPortalViewUrl: (id?: ResourceId, taskId?: string) =>
      `${getSingleEntityUrl(id)}/client-portal-task/${taskId}`,
    getCreateRiskUrl: (id?: ResourceId) => `${getSingleEntityUrl(id)}/risk`,
    getUpdateRiskUrl: (id?: ResourceId, riskId?: string) => `${getSingleEntityUrl(id)}/risk/${riskId}`,
    getCreateWasteUrl: (id?: ResourceId) => `${getSingleEntityUrl(id)}/waste`,
    getUpdateWasteUrl: (id?: ResourceId, wasteId?: string) => `${getSingleEntityUrl(id)}/waste/${wasteId}`,
    getPreviewWasteUrl: (id?: ResourceId, wasteId?: string) => `${getSingleEntityUrl(id)}/waste/${wasteId}/preview`,
    getCreateCriticalPeriodUrl: (id?: ResourceId) => `${getSingleEntityUrl(id)}/critical-period/create`,
    getUpdateCriticalPeriodUrl: (id?: ResourceId, criticalPeriodId?: string) =>
      `${getSingleEntityUrl(id)}/critical-period/${criticalPeriodId}/update`,
    getCreateBillingScheduleUrl: (id?: ResourceId) => `${getSingleEntityUrl(id)}/billing`,
    getCreateBillingRequestUrl: ({
      billingScheduleId,
      billingItemId,
    }: {
      billingScheduleId: string;
      billingItemId: string;
    }) => `/billing/${billingScheduleId}/${billingItemId}/create`,
    getUpdateBillingRequestUrl: ({
      billingScheduleId,
      billingRequestId,
    }: {
      billingScheduleId: string;
      billingRequestId: string;
    }) => `/billing/${billingScheduleId}/${billingRequestId}/update`,
    getApproveBillingRequestUrl: ({
      billingScheduleId,
      billingRequestId,
    }: {
      billingScheduleId: string;
      billingRequestId: string;
    }) => `/billing/${billingScheduleId}/${billingRequestId}/approve`,
    getPreviewBillingRequestUrl: ({
      billingScheduleId,
      billingRequestId,
    }: {
      billingScheduleId: string;
      billingRequestId: string;
    }) => `/billing/${billingScheduleId}/${billingRequestId}/preview`,
    getUpdateBillingInvoiceDatesUrl: (billingScheduleId: string) =>
      `/billing/${billingScheduleId}/invoice-dates/update`,
    getMigrateBillingRequestUrl: ({
      billingScheduleId,
      billingItemId,
    }: {
      billingScheduleId: string;
      billingItemId: string;
    }) => `/billing/${billingScheduleId}/${billingItemId}/migrate`,
    getUpdateMigratedBillingRequestUrl: ({
      billingScheduleId,
      billingRequestId,
    }: {
      billingScheduleId: string;
      billingRequestId: string;
    }) => `/billing/${billingScheduleId}/${billingRequestId}/update-migrated`,
  };
};
